import Corvey1 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (1).webp'
import Corvey2 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (2).webp'
import Corvey3 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (3).webp'
import Corvey4 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (4).webp'
import Corvey5 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (5).webp'
import Corvey6 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (6).webp'
import Corvey7 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (7).webp'
import Corvey8 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (8).webp'
import Corvey9 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (9).webp'
import Corvey10 from '../../../Media/Citraland Kedamaian/Corvey/Corvey (10).webp'


const Corveyimages =[
Corvey1,Corvey2,Corvey3,Corvey4,Corvey5,Corvey6,Corvey7,Corvey8,Corvey9,Corvey10
]

export default Corveyimages;